import cn from 'classnames';
import Link from 'next/link';

import ScaleHead from 'react-scale/components/ui/head';
import Loading from 'react-scale/components/ui/loading';

import ScaleLogo from 'react-scale/components/tailwind/ScaleLogo';
import { useToggleState } from 'react-scale/hooks/use-toggle-state';
import { useEffect } from 'react';
import MobileMenu from './mobile-menu';

const leftSideLinks = [
  {
    href: '/events/transformx/in-person',
    label: 'In Person'
  },
  {
    href: '/events/transformx/sponsorship',
    label: 'Sponsorship'
  },
  {
    href: '/events/transformx/speakers',
    label: 'Past Speakers'
  },
  {
    href: '/events/transformx/call-for-speakers',
    label: 'Call For Speakers'
  }
];

const Header = ({ className, ...props }) => {
  const mobileMenuState = useToggleState();

  useEffect(() => {
    if (mobileMenuState.isOn) {
      document.body.style.setProperty('overflow', 'hidden');
    } else {
      document.body.style.removeProperty('overflow');
    }

    return () => {
      document.body.style.removeProperty('overflow');
    };
  }, [mobileMenuState.isOn]);

  return (
    <header
      className={cn(
        'z-40 sticky top-0 transition',
        {
          'bg-black/60 backdrop-filter backdrop-blur-sm backdrop-saturate-150':
            !mobileMenuState.isOn,
          'bg-black/100': mobileMenuState.isOn
        },
        className
      )}
    >
      <ScaleHead {...props} />
      <Loading />
      <div className="container h-16 md:h-20">
        <div className="flex items-center justify-between h-full lg:hidden">
          <HeaderLogo />
          {/* <RegisterWithLinkedInButton className="text-sm font-medium" /> */}
          <MobileMenu {...mobileMenuState} />
          {/* <MenuMobile /> */}
        </div>
        <div className="relative z-30 items-center justify-between hidden h-full lg:flex">
          <div className="flex justify-center">
            <HeaderLogo />
          </div>
          <nav className="relative flex items-center">
            <ul className="flex space-x-10">
              {leftSideLinks.map(({ href, label }) => (
                <li key={`link-${label}`}>
                  <Link href={href}>
                    <a className="text-sm font-medium">{label}</a>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

const HeaderLogo = () => (
  <Link href="/events/transformx">
    <a>
      <div className="flex items-center space-x-2">
        <span className="h-[21px] sm:h-[18px] mt-[-2px]">
          <ScaleLogo className={cn('w-auto h-full fill-current text-white')} />
        </span>
        <p className="text-[28px] font-aeonik sm:text-2xl text-transform-x-gradient">TransformX</p>
      </div>
    </a>
  </Link>
);

// const MenuMobile = ({ onClick, color }) => (
//   <div className="flex items-center cursor-pointer lg:hidden" onClick={onClick}>
//     <svg className={cn('w-6 h-auto fill-current', color)} viewBox="0 0 24 12">
//       <rect width="24" height="2" />
//       <rect y="5" width="24" height="2" />
//       <rect y="10" width="24" height="2" />
//     </svg>
//   </div>
// );

export default Header;
